import {
  PersistedFormGroup,
  PersistedFormArray,
  PersistedArray,
} from './persisted-form-group';
import type {
  PersistedFormGroupOptions,
  PersistedFormArrayOptions,
  PersistedArrayOptions,
} from './persisted-form-group';
import type { SchemaFormControl } from '@apexdesigner/schema-forms';
import { ProcessFunction } from './process-function';
export { ProcessFunction };
import { processFunctionSchema } from '@schemas/business-objects/process-function';
import { ProcessDataTypeFormGroup } from './process-data-type-form-group';
import { ProcessFunctionParameterFormArray } from './process-function-parameter-form-group';

export class ProcessFunctionFormGroup extends PersistedFormGroup {
  declare controls: {
    id: SchemaFormControl;
    name: SchemaFormControl;
    displayName: SchemaFormControl;
    description: SchemaFormControl;
    returnsArray: SchemaFormControl;
    typescript: SchemaFormControl;
    parameters: ProcessFunctionParameterFormArray;
    returnTypeId: SchemaFormControl;
    returnType: ProcessDataTypeFormGroup;
  };

  declare value: Partial<ProcessFunction>;

  constructor(
    data?: Record<string, any> | null,
    options?: PersistedFormGroupOptions,
  ) {
    super(processFunctionSchema, ProcessFunction, data, options);
  }

  get object(): ProcessFunction {
    return new ProcessFunction(this.getRawValue());
  }

  protected override createControl(name: string) {
    switch (name) {
      case 'parameters':
        return new ProcessFunctionParameterFormArray();
      case 'returnType':
        return new ProcessDataTypeFormGroup();
      default:
        return undefined;
    }
  }

  static async find(filter?: any): Promise<ProcessFunction[]> {
    return ProcessFunction.find(filter);
  }

  static async findOne(filter?: any): Promise<ProcessFunction | null> {
    return ProcessFunction.findOne(filter);
  }

  static async findById(id: string, filter?: any): Promise<ProcessFunction> {
    return ProcessFunction.findById(id, filter);
  }

  static async create(
    data: Partial<ProcessFunction>,
  ): Promise<ProcessFunction> {
    return ProcessFunction.create(data as any);
  }

  static async updateById(
    id: string,
    updates: Partial<ProcessFunction>,
  ): Promise<ProcessFunction> {
    return ProcessFunction.updateById(id, updates as any);
  }

  static async deleteById(id: string): Promise<boolean> {
    return ProcessFunction.deleteById(id);
  }
}

export class ProcessFunctionFormArray extends PersistedFormArray {
  declare controls: ProcessFunctionFormGroup[];

  readonly entityName = 'ProcessFunction' as const;

  constructor(options?: PersistedFormArrayOptions) {
    super(processFunctionSchema, ProcessFunction, options);
  }

  protected override createItemGroup() {
    return new ProcessFunctionFormGroup();
  }

  get array(): ProcessFunction[] {
    return this.controls.map((group: ProcessFunctionFormGroup) => group.object);
  }
}

export class ProcessFunctionPersistedArray extends PersistedArray<ProcessFunction> {
  readonly entityName = 'ProcessFunction' as const;

  constructor(options?: PersistedArrayOptions) {
    super(ProcessFunction, options);
  }
}
